import { Link } from "react-router-dom";
import { Facebook, Instagram } from "lucide-react";

const links = [
  { to: "/privacy", label: "Privacy Policy", testid: "footer-privacy" },
  { to: "/terms", label: "Terms of Service", testid: "footer-terms" },
  { to: "/affiliate-disclosure", label: "Affiliate Disclosure", testid: "footer-affiliate" },
  { to: "/how-it-works", label: "How Willoah Works", testid: "footer-how-it-works" },
];

// Official Willoah brand accounts. Kept as external anchors (rel=noopener
// noreferrer) so the tab isolation is proper on Safari + Android.
const social = [
  {
    label: "Instagram",
    handle: "@heywilloah",
    href: "https://www.instagram.com/heywilloah",
    Icon: Instagram,
    testid: "footer-instagram",
  },
  {
    label: "Facebook",
    handle: "Willoah",
    href: "https://www.facebook.com/share/1G9LTeTVLK/",
    Icon: Facebook,
    testid: "footer-facebook",
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[#B79256]/25 mt-24 pt-10 pb-12 no-print"
    >
      <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row md:items-baseline md:justify-between gap-6">
        <div>
          <div className="font-serif-display text-2xl text-[#2A2823]">Willoah</div>
          <div className="accent-label text-[#B79256] mt-1">real life. real ideas.</div>
          <div className="text-xs text-[#2A2823]/55 mt-4">
            Contact:{" "}
            <a
              href="mailto:hello@willoah.com"
              data-testid="footer-contact"
              className="text-[#4E5A3D] hover:text-[#3E4830] underline underline-offset-2"
            >
              hello@willoah.com
            </a>
          </div>

          {/* Follow us — sits under the contact line so it reads as part of
              the "how to reach Willoah" cluster on the left. */}
          <div className="mt-5" data-testid="footer-social">
            <div className="accent-label text-[#B79256] mb-2">Follow us on</div>
            <div className="flex items-center gap-2">
              {social.map(({ label, handle, href, Icon, testid }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Willoah on ${label}`}
                  data-testid={testid}
                  className="inline-flex items-center gap-2 rounded-full border border-[#B79256]/40 px-3 py-1.5 text-xs text-[#2A2823]/80 hover:text-[#4E5A3D] hover:border-[#4E5A3D]/60 hover:bg-[#4E5A3D]/5 transition-colors"
                >
                  <Icon className="w-3.5 h-3.5" strokeWidth={1.75} />
                  <span>{label}</span>
                  <span className="text-[#2A2823]/45">{handle}</span>
                </a>
              ))}
            </div>
          </div>
        </div>
        <nav className="flex flex-wrap gap-x-6 gap-y-2">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              className="accent-label text-[#2A2823]/70 hover:text-[#4E5A3D] transition-colors"
            >
              {l.label}
            </Link>
          ))}
        </nav>
      </div>
      <div className="max-w-6xl mx-auto px-6 mt-8 text-xs text-[#2A2823]/50">
        © {new Date().getFullYear()} Willoah. All rights reserved.
      </div>
    </footer>
  );
}
